import { render } from "./ShowAmbulance2.vue?vue&type=template&id=1ba06dfc&scoped=true"
import script from "./ShowAmbulance2.vue?vue&type=script&lang=js"
export * from "./ShowAmbulance2.vue?vue&type=script&lang=js"

import "./ShowAmbulance2.vue?vue&type=style&index=0&id=1ba06dfc&scoped=true&lang=scss"
import "./ShowAmbulance2.vue?vue&type=style&index=1&id=1ba06dfc&lang=css"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba06dfc"]])

export default __exports__